import SSN from 'french-ssn'
import validator from 'validator'

import i18n from 'modules/core/lib/i18n'

import type { IdValidationStrategy } from 'modules/legal_entities/lib/types'

import validateFrenchCNI from './cniValidator'
import { FranceIdType } from './idType'

class FranceIdValidationStrategy implements IdValidationStrategy {
  constructor(private idType: FranceIdType, private id: string, private idLabel: string) {}
  isValid(): boolean {
    if (this.disabled()) return true

    switch (this.idType) {
      case FranceIdType.PASSPORT:
        return validator.isPassportNumber(this.id, 'FR')
      case FranceIdType.NTT:
        const nttPattern = /^[1-2][a-zA-Z0-9]{10,39}$/
        return nttPattern.test(this.id)
      case FranceIdType.NIA:
        const niaPattern = /^[a-zA-Z0-9]{10}$/
        return niaPattern.test(this.id)
      case FranceIdType.NIR:
        return SSN.validate(this.id)
      case FranceIdType.CNI:
        return validateFrenchCNI(this.id)
      default:
        return false
    }
  }
  errors(): string {
    if (!this.isValid()) {
      return i18n.t('employee_form.invalid_number', { document: this.idLabel })
    }
    return ''
  }
  disabled(): boolean {
    return FranceIdType.PASSPORT == this.idType
  }
}

export default FranceIdValidationStrategy
